
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Cystocele(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Cystocele (bladder hernia)"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    A cystocele, also known as a <b>prolapsed bladder,</b> is a medical
                                    condition in which a woman's bladder bulges into her vagina. Some
                                    may have no symptoms. Others may have trouble starting urination,
                                    urinary incontinence, or frequent urination.
                                </p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/cystocele(bladder-hernia)/1.png")} alt="cystocele(bladder-hernia)" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p>In mild cases of anterior prolapse, you may not notice any signs or symptoms. When signs and
                                    symptoms occur, they may include:</p>
                                <p>A feeling of fullness or pressure in your pelvis and vagina</p>
                                <p>In some cases, a bulge of tissue in your vagina that you can see or feel</p>
                                <p>Increased pelvic pressure when you strain, cough, bear down or lift</p>
                                <p>Problems urinating, including difficulty starting a urine stream, the feeling that you haven't
                                    completely emptied your bladder after urinating, feeling a frequent need to urinate or leaking
                                    urine (urinary incontinence)</p>
                                <p>Signs and symptoms often are especially noticeable after standing for long periods of time and may go
                                    away when you lie down.</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Cystocele">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Cystocele;